import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type CompaniesMarketsStoriesProps = {
  /** Individual article */
  cardProps: ComponentProps<typeof Card>;
  /** Index of the article in the list */
  index: number;
};

const CompaniesMarketsStories = ({
  cardProps,
  index,
}: CompaniesMarketsStoriesProps): React.ReactElement => {
  const variant: CardVariations = {
    kicker: {
      color: "text-gray-515",
    },
    title: {
      color: "text-gray-850",
      size: "text-base",
      extraClass: "font-lct my-1",
    },
    content: {
      width: "w-full",
      extraClass: "h-full",
      updatedTimeColor: "text-red",
      updatedTimeExtraClass: "text-7xs",
    },
  };

  return (
    <div
      className={cn("story border-b border-gray-175 py-3 lg:col-span-1", {
        "lg:order-1": index < 6,
        "lg:order-3": index === 6,
        "lg:border-none": index === 2 || index === 5,
        "border-none lg:border-b": index === 5,
      })}
      data-testid="homepage-companies-market-stories-individual-component"
    >
      <Card
        {...cardProps}
        variations={variant}
        className={cn("h-full border-gray-175", {
          "lg:border-r lg:pr-3": index < 3,
          "lg:pl-3": index > 2,
          "lg:pr-3": index > 2 && index != 6,
        })}
      />
    </div>
  );
};

export default CompaniesMarketsStories;
